import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { MdDownloadForOffline } from 'react-icons/md';
import { AiTwotoneDelete } from 'react-icons/ai';
import { BsFillArrowUpRightCircleFill } from 'react-icons/bs';
import {Routes,Route} from 'react-router-dom'
import { client, urlFor } from '../client';
import {Feed,Navbar,CreatePin,PinDetail,Search} from '../components'

function Pins({user}) {
    const [searchTerm,setSearchTerm] = useState('')
  return (
    <div className='px-2 md:px-5'>
        <div className='bg-gray-50'>
<Navbar searchTerm={searchTerm} setSerachTerm={setSearchTerm}  user={user}/>
        </div>
        <div className='h-full'>
<Routes>
    <Route  path='/' element={<Feed />}/>
    <Route  path='/category/:categoryId' element={<Feed />}/>
    <Route  path='/pin_detail/:pinId' element={<PinDetail user={user} />}/>
    <Route  path='/createPin' element={<CreatePin user={user} />} />
    <Route  path='/search' 
    element={<Search  searchTerm={searchTerm} 
    setSearchTerm={setSearchTerm} user={user} />}/>
</Routes>
        </div>
    </div>
  )
}

export default Pins